import React from "react";
import CreditPacks from "../CreditPacks";
import { useCredits } from "../../context/CreditsContext";
import { modelBadge } from "../ModelSelect";

export const Pricing = ({ onBuy }) => {
  const { models } = useCredits();
  return (
    <section id="pricing" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
      <div className="grid lg:grid-cols-12 gap-10 mb-12">
        <div className="lg:col-span-7">
          <span className="text-xs font-mono uppercase tracking-wider text-emerald-600">Pricing</span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">Simple credit packs. Pay only for what you use.</h2>
          <p className="mt-4 text-slate-500 leading-relaxed max-w-xl">
            Buy a credit pack once — <span className="text-slate-900 font-medium">no subscriptions, credits never expire</span>. Each message to the AI uses credits depending on the model you pick.
          </p>
        </div>
        <div className="lg:col-span-5 rounded-2xl border border-slate-200 bg-white p-5 space-y-3" data-testid="pricing-model-costs">
          {models.map((m) => (
            <div key={m.id} className="flex items-center justify-between gap-3">
              <div>
                <div className="text-sm text-slate-900">{m.label}</div>
                <div className="text-xs text-slate-500">{m.tagline}</div>
              </div>
              <span className={`shrink-0 px-2 py-0.5 rounded border text-xs font-mono ${modelBadge(m.id)}`}>{m.credits} cr / message</span>
            </div>
          ))}
        </div>
      </div>
      <CreditPacks onBuy={onBuy} cta="Get credits" />
    </section>
  );
};

export default Pricing;
